import { render } from "./DropdownButton.vue?vue&type=template&id=f390d7a6&scoped=true"
import script from "./DropdownButton.vue?vue&type=script&lang=ts"
export * from "./DropdownButton.vue?vue&type=script&lang=ts"

import "./DropdownButton.vue?vue&type=style&index=0&id=f390d7a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f390d7a6"

export default script